export default class StatusBadge {
  id;

  icon = null;

  color = 'black';

  message;

  constructor({ id, message, icon, color }) {
    this.id = id;
    this.message = message;
    // Optional vars
    if (color) this.color = color;
    if (icon) this.icon = icon;
  }
}
